import { call } from "actionware/lib/call";
import { onError, onSuccess } from "actionware/lib/listeners";

import { authenticatedApiFetch } from "../../common/helpers";
import { toggleConfirmationModal } from "../confirmationModal/confirmationModalActions";

export function saveNewCycleData(action, data) {
  return { action, data };
}

export function setCurrentViewPage(data) {
  return data;
}

export function resetToInitialState() {
  return;
}

export function toggleBannerView(data) {
  return data;
}

export function toggleErrorCard(data) {
  return data;
}

export const getFundingCycle = async () => {
  return await authenticatedApiFetch(
    "cycle",
    "GET"
    // params
  ).then((result) => {
    return result && result.data;
  });
};

export async function getProductsList(params = { status: "pending" }) {
  return await authenticatedApiFetch("products", "GET").then(
    (result) => {
      return result && result.data && result.data.products;
    }
  );
}

export const getLendersList = async (params = { status: "pending" }) => {
  return await authenticatedApiFetch(
    "lender/profiles",
    "GET",
    params
  ).then((result) => {
    // Filter out the specific lender "PT Julo Teknologi Perdana" as specification of FINSERV-48690
    const filteredData = result.data.filter(lender => 
      lender.lender_name !== "PT Julo Teknologi Perdana"
    );
    return filteredData;
  });
};

export async function persistNewCycleData(params) {
  return await authenticatedApiFetch(
    "cycle",
    "POST",
    params
  );
}

function showBannerAndToggleModal(bannerObject) {
  call(toggleConfirmationModal);
  call(toggleBannerView, bannerObject);
  call(resetToInitialState);
}

onSuccess(persistNewCycleData, (store, data) => {
  showBannerAndToggleModal({
    showFlag: true,
    isError: false,
    title: "fundingLimit.ovo_admin_body_new_cycle_scheduled",
  });
});

//TODO: In later phases we can add scenarious to decide if we reroute to landing page
//or remain on setup cycle based on BE errors and surface them appropriately in field values
onError(persistNewCycleData, (state, error) => {
  showBannerAndToggleModal({
    showFlag: true,
    isError: true,
    title: "confirmationModal.ovo_admin_body_failed_to_save_changes",
  });
});

export async function persistEditCurrentCycleData(params) {
  return await authenticatedApiFetch("cycle", "PUT", params);
}

onSuccess(persistEditCurrentCycleData, (store, data) => {
  showBannerAndToggleModal({
    showFlag: true,
    isError: false,
    title: "fundingLimit.ovo_admin_body_lender_ranking_updated_funding_limit",
  });
});

onError(persistEditCurrentCycleData, (state, error) => {
  showBannerAndToggleModal({
    showFlag: true,
    isError: true,
    title: "confirmationModal.ovo_admin_body_failed_to_save_changes",
  });
});
